export async function loadScript(
    src: string,
    crossOrigin?: '' | 'anonymous' | 'use-credentials' | undefined
): Promise<void> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;

        if (crossOrigin) {
            script.crossOrigin = crossOrigin;
        }

        script.onload = () => resolve();
        script.onerror = reject;

        document.head.appendChild(script);
    });
}
